// extracted by mini-css-extract-plugin
module.exports = {"Logo":"logo_Logo__1KXQ4"};